import { render, staticRenderFns } from "./CanvasReaction.vue?vue&type=template&id=53027e6e&"
import script from "./CanvasReaction.vue?vue&type=script&lang=js&"
export * from "./CanvasReaction.vue?vue&type=script&lang=js&"
import style0 from "./CanvasReaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports